var React = require('react');

function Home (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .a {\n        fill: #909090;\n      }\n    ")),React.createElement("path",{"className":"a","d":"M8.67,11H6.19a.42.42,0,0,1-.43-.42v-3s-.09-.14-.23-.14H4.05c-.14,0-.23.09-.23.14v3a.43.43,0,0,1-.43.42H1a1,1,0,0,1-1-1V4.53H0a.33.33,0,0,1,0-.15H0a.45.45,0,0,1,.1-.14h0L4.51.12a.45.45,0,0,1,.6,0l4.38,4h0a.45.45,0,0,1,.1.13h0a.58.58,0,0,1,0,.14v0L9.67,10A1,1,0,0,1,8.67,11ZM4.05,6.57H5.53a1,1,0,0,1,1.09,1v2.63H8.67A.14.14,0,0,0,8.81,10l0-5.47L4.82,1,.86,4.7V10a.15.15,0,0,0,.15.14H3V7.54A1,1,0,0,1,4.05,6.57Z","key":1})]);
}

Home.defaultProps = {"viewBox":"0 0 9.67 11"};

module.exports = Home;

Home.default = Home;
